import aboutHero from "@/assets/about/hero.webp?w=640;960;1280;1920;2560;3780&format=webp&as=meta";
import { responsiveImage } from "@/lib/responsiveImage";
import { CareersSection } from "@/components/about/CareersSection";
import { DeviceReveal } from "@/components/about/DeviceReveal";
import { StorySection } from "@/components/about/StorySection";
import { AboutTeamSection } from "@/components/about/AboutTeamSection";
import { WhySomoSection } from "@/components/about/WhySomoSection";
import { CtaRow } from "@/components/CtaRow";
import { SectionDivider } from "@/components/Divider";
import { PageShell } from "@/components/PageShell";
import { PageHero } from "@/components/PageHero";
import { SITE } from "@/lib/site";

export function AboutPage() {
  return (
    <PageShell className="bg-primary" flushBottom>
      <PageHero
        image={responsiveImage(aboutHero)}
        imagePosition="14% center"
        imageAlt="Somo keypads on a guest bathroom wall beside the vanity"
        title="Hospitality deserves better technology"
        body="Somo was founded on a simple belief: hotel technology should be as considered as the experience itself. We bring together expertise in hospitality, connected systems, design, and technology to build better guest rooms."
        align="start"
        cta={{
          label: "Explore the Ecosystem",
          href: `${SITE}/meet-somo#ecosystem`,
        }}
        caption="Somo at Huntington"
      />
      <StorySection />
      <DeviceReveal />
      <WhySomoSection />
      <AboutTeamSection />
      <SectionDivider />
      <CareersSection />
      <div className="rounded-b-3xl bg-secondary">
        <CtaRow
          title="Bring Somo to your property"
          body="See how Somo can create a better experience for your guests, your operations, and your bottom line."
          cta={{ label: "Let’s Talk", href: `${SITE}/contact` }}
        />
      </div>
    </PageShell>
  );
}
